import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/closed-captioning': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM458 400H54C50.7 400 48 397.3 48 394V118C48 114.7 50.7 112 54 112H458C461.3 112 464 114.7 464 118V394C464 397.3 461.3 400 458 400zM246.9 314.3C248.6 316.7 248.4 319.9 246.4 322 192.8 378.8 73.6 354.1 73.6 254.1 73.6 156.8 195.3 134.6 246.1 184 248.2 186 248.6 187.2 247.1 189.7L229.6 220.2C227.7 223.3 223.4 224.2 220.5 221.9 179.7 189.9 125.9 207 125.9 253.1 125.9 301.1 176.9 323.6 218.1 285.7 220.9 283.2 225.2 283.6 227.3 286.6L246.9 314.3zM437.3 314.3C439 316.7 438.8 319.9 436.8 322 383.2 378.9 264 354.1 264 254.1 264 156.8 385.7 134.6 436.5 184 438.6 186 439 187.2 437.5 189.7L420 220.2C418.1 223.3 413.8 224.2 410.9 221.9 370.1 189.9 316.3 207 316.3 253.1 316.3 301.1 367.3 323.6 408.5 285.7 411.3 283.2 415.6 283.6 417.7 286.6L437.3 314.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/closed-captioning.js
// module id = Zxs/
// module chunks = 144